<template>
  <button
    :class="{
      'vue-loading-button': true,
      loading: loading
    }"
    :disabled="loading"
    :type="type"
  >
    <slot>Submit</slot>
    <span class="spinner">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </span>
  </button>
</template>

<script>
  export default {
    name: "VueLoadingButton",
    props: {
      loading: {
        type: Boolean,
        required: false,
        default: false
      },
      styled: {
        type: Boolean,
        required: false,
        default: false
      },
      type: {
        type: String,
        reuired: false,
        default: "button"
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/settings/_color.scss";
  .btn {
    padding: 12px 60px;
    border: none;
    cursor: pointer;
    position: relative;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
    transition-timing-function: ease-in;
    &.btn-primary {
      background-color: $color-primary;
      color: white;
      text-transform: uppercase;
      font-size: 14px;
    }
    &.btn-secondary {
      padding: 12px 40px;
      background-color: white;
      color: $color-primary;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 700;
      border: 1px solid $color-primary;
      &:hover {
        filter: brightness(90%);
      }
    }
    &:hover {
      filter: brightness(80%);
    }
    .spinner {
      line-height: 1.15;
      position: absolute;
      top: 8px;
      right: 30px;
      opacity: 0;
      transition-property: padding, opacity;
      transition-duration: 0.2s, 0.2s;
      transition-timing-function: ease-in, ease;
      transition-delay: 0s, 0.2s;
      span {
        box-sizing: border-box;
        display: inline-block;
        position: absolute;
        right: 0;
        top: 0.15rem;
        width: 1rem;
        height: 1rem;
        opacity: 1;
        border: 3.4px solid white;
        border-radius: 50%;
        animation: spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: white transparent transparent transparent;
      }
      span:nth-child(1) {
        animation-delay: 0.45s;
      }
      span:nth-child(2) {
        animation-delay: 0.3s;
      }
      span:nth-child(3) {
        animation-delay: 0.15s;
      }
    }
    &.loading {
      .spinner {
        opacity: 1;
      }
      span {
        opacity: 1;
      }
    }
    @keyframes spinner {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }

  button:disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }

  button:not(:disabled) .spinner span:nth-child(1) {
    transform: rotate(0deg) !important;
  }

  button:not(:disabled) .spinner span:nth-child(2) {
    transform: rotate(90deg) !important;
  }

  button:not(:disabled) .spinner span:nth-child(3) {
    transform: rotate(180deg) !important;
  }

  button:not(:disabled) .spinner span:nth-child(4) {
    transform: rotate(270deg) !important;
  }

  button:not(:disabled) {
    transition-delay: 0.2s;
  }
</style>
